/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, { useContext, useEffect, useMemo, useState} from "react";
import {Alert, Button, Descriptions, Spin, Tabs} from "antd";
import {getApiHost, getLastDomByClassName, numberWithCommas} from "../../../utils";
import Axios from "axios";
import loadJS from "load-js";
import MapPropsContext from "../MapPropsContext";
import useDebounce from "../../../utils/hooks/useDebounce";
import usePortal from "react-useportal";
import ChartPane from "./ChartPane";


const ICON_MAPPING = {
  //2020.06.01 : 화면 표기를 위한 아이콘 정렬 변경
  '11': ['5g-sk-in', 'SKT 3.5G'],
   '21': ['5g-kt-in', 'KT 3.5G'],
  '31': ['5g-lg-in', 'LGU+ 3.5G'],
  '12': ['5g-sk-out', 'SKT 28G'],
   '22': ['5g-kt-out', 'KT 28G'],
  '32': ['5g-lg-out', 'LGU+ 28G'],
};
// 필요한 목록 : 선택한 주파수 리스트, 시도코드, 아이콘 매핑 배열
const RMateChartTableImpCheck = ({frqList, sidoCode, disable, isVisible}) => {

  const [isInit, setIsInit] = useState(false);
  const chartProfile = window.CHART_PROFILE || "test";

  useEffect(() => {
    let chartUrlList = [
      `/js/chart/LicenseKey/${chartProfile}/rMateChartH5License.js`,
      "/js/chart/rMateIntegrationH5.js",
      "/js/chart/theme.js",
      "/js/chart/shCore.js",
      "/town_radiomap.js",
    ];
    loadJS(chartUrlList).then(() => {
      setIsInit(true);
    });
  }, []);

  const [visible, setVisible] = useState(false);
  const {
    iconDict,
    widgetState,
    clickedPointIconObjects,
    setClickedPointIconObjects,
  } = useContext(MapPropsContext);

  const iconCheckedList = useMemo(() => {
    if (ICON_MAPPING && Object.keys(iconDict).length > 0) {
      let array = [];
      for (let [frqCode, stats] of Object.entries(ICON_MAPPING)) {
        if (frqList.includes(frqCode)) {
          const iconCode = stats[0];
          array.push([frqCode, iconDict[iconCode].data]);
        }
      }
      return array;
    }
    return [];
  }, [frqList, visible]);

  // as-is의 데이터 통신 사용하기 - 지역별 정보
  const [tableDistrictData, setTableDistrictData] = useState();

  // as-is의 데이터 통신 사용하기 - 주파수 정보
  const [tableFrqData, setTableFrqData] = useState();

  /*
    서버통신을 위한 쿼리스트링 제작
    '!422009375!,!422040625!' 모양
   */
  const settingString = (checkList) => {
    // as-is 의 문자열 만들기 모양 : "2G,3G,LTE"
    const customArray = checkList.map(checkpItem => {
      return '!' + checkpItem.substr(0, 3) + checkpItem.substr(4, 7) + '!'
    });
    return customArray.toString();
  };

  const {Portal} = usePortal({
    bindTo: getLastDomByClassName('toolbar-show-chart'),
  });

  const {frq_list} = widgetState;
  useEffect(() => {
    if (frq_list.length === 0) {
      setVisible(false);
    }
  }, [frq_list]);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [parsedObject, setParsedObject] = useState({});

  useDebounce(() => {
    if (isInit && frq_list.length !== 0) {
      setIsLoading(true);
      setError(null);
      setParsedObject({});

      const url_district = getApiHost() + '/gisToolView/getImpCheckStatistics.do';
      const url_frq = getApiHost() + '/gisToolView/getStatisticsBand.do';

      const formData = new FormData();

      formData.append('menuNo', '300624');
      formData.append('gisViewId', 'GIS_000003');
      formData.append('targetMYn', 'Y');
      formData.append('targetFYn', 'Y');
      formData.append('targetAYn', 'N');
     // formData.append('whereMaster', 'AND A.PMS$RDS_STA_CD IN ( @02@,@00@,@01@ )  AND A.PMS$RAD_CLS_CD = @94@');
      formData.append('whereFrq', 'AND FRQ_HZ BETWEEN 10 AND 50');
      formData.append('whereArw', '');
      formData.append('disColItem', '');
      formData.append('sheetTitle', '사용자정의 데이터');
      formData.append('fileName', '사용자 정의 데이터.xlsx');
      formData.append('sortName', '');
      formData.append('orderBy', '');
      formData.append('frq_hz', settingString(frqList));
      formData.append('searchSid', sidoCode);

      // 지역별 정보, 주파수별 정보를 얻어내는 통신을 한 데 묶어 통신(순서대로가져옴)
      Axios.all([
          Axios.post(url_district, formData),
          Axios.post(url_frq, formData)
        ]
      ).then(Axios.spread((districtResponse, frqResponse) => {
        // 지역별 데이터는 리스트, 최대, 간격을 DB에서 계산해서 가져옴.
        const districtData = districtResponse['data'];
        const districtMax = districtData['maximum'];
        const districtInterval = districtData['interval'];
        const districtList = districtData['rows'];
        // 테이블에 넣을 데이터를 먼저 세팅
        setTableDistrictData(districtList);
        // 차트에 쓰일 데이터는 0값을 제외함

        const chartDistrictData = dataZeroRemoveFn(districtList);
        // 주파수별 데이터는 데이터에서 최대, 간격을 가져와야함.
        const frqData = frqResponse['data'];
        const chartFrqData = frqData['rows'];

        setTableFrqData(chartFrqData);


        setParsedObject({
          chartDistrictData, districtMax, districtInterval,
          chartFrqData
        });

      })).catch((e1, e2) => {
        console.error(e1, e2);
        setError(e1, e2);
      }).finally(() => {
        setIsLoading(false);
        setVisible(true);
      });
    }
  }, 2000,
  [isInit, frqList, sidoCode, setIsLoading, setParsedObject]);

  // 오른쪽 상단 레이어 하나만 띄우기, 아이콘 클릭 시 차트 레이어 닫기
  useEffect(() => {
    if(clickedPointIconObjects && clickedPointIconObjects.length > 0){
      setVisible(false);
    }
  }, [visible, clickedPointIconObjects]);

  const {
    chartDistrictData, districtMax, districtInterval,
    chartFrqData
  } = parsedObject;

  return (
    <>
      <Portal>
        <Button disabled={disable}
                type={
                  visible ? "primary" : undefined
                }
                onClick={()=>{
                  // 차트보기 레이어 띄울 때는 아이콘 정보 레이어 없애기
                  setClickedPointIconObjects([]);
                  setVisible(!visible);
                }}
        >
          차트 보기
        </Button>
      </Portal>

      <div style={CHART_PANE_STYLE} hidden={!visible} class={"rmatechart-town-r"}>
        {/*{isLoading && <Spin style={{position: 'absolute', left: '50%', top: '50%', zIndex: 1}} size={"large"}/>}*/}
        {isLoading &&
          <div style={{position: 'absolute', top: 55, zIndex: 1, height: '90%', width: '100%', backgroundColor: 'white'}}>
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{height: '470px'}}
              />
            </Spin>
          </div>
        }
        <Tabs defaultActiveKey={"district"} type={"card"}>
          <Tabs.TabPane tab="지역별 정보" key={"district"}>
            <>
              <div style={STYLE_SUBMIT}>
                <Button onClick={() => setVisible(false)}>
                  닫기
                </Button>
              </div>
              <div style={STYLE_CONTENT}>
                {error &&
                <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"}/>
                }

                {!isLoading && tableDistrictData &&
                <Descriptions bordered
                              title={'총 ' + tableDistrictData.length + ' 개 지역의 ' +
                              numberWithCommas(tableDistrictData.reduce((prev, next) => prev + next.cnt, 0)) + ' 개 이행점검완료 무선국'}
                              size={"small"}
                              column={3}>
                  {tableDistrictData.map(({disNm, cnt}) =>
                    <Descriptions.Item key={disNm} label={disNm}>{numberWithCommas(cnt)}</Descriptions.Item>
                  )}
                </Descriptions>
                }
              </div>
              <br/>
              <ChartPane data={chartDistrictData}
                         processor={() => chartDistrictData}
                         layoutProcessor={() => setChartLayoutBar(districtMax, districtInterval)}
                         style={
                           {height: 500, width: '100%'}
                         }
              />
            </>
          </Tabs.TabPane>
          <Tabs.TabPane tab="대역별 정보" key={"frq"}>
            <>
              <div style={STYLE_SUBMIT}>
                <Button onClick={() => setVisible(false)}>
                  닫기
                </Button>
              </div>
              <div style={STYLE_CONTENT}>
                {error &&
                <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"}/>
                }
                {/*2020.06.01 : MHz 단위 표기 추가*/}

                {!isLoading && tableFrqData &&
                <Descriptions bordered
                              title={'총 ' + numberWithCommas(tableFrqData.reduce((prev, next) => prev + next.cnt, 0)) + ' 개'}
                              size={"small"}
                              column={3}>
                  //2020.06.01 : 화면 표기를 위한 메인루프 변경
                  {iconCheckedList.map(([frqCode, iconDictData]) =>
                    tableFrqData.map(({band,frq, cnt}, index) => {
                        if (frq === frqCode) {
                          return (
                            <Descriptions.Item label={
                              <div key={index}>
                                <img src={iconDictData} style={{width: 24}} alt={""}/>{band}
                              </div>}
                            >{numberWithCommas(cnt)}
                            </Descriptions.Item>
                          )
                        } else {
                          return null;
                        }
                      }
                    )
                  )}
                </Descriptions>
                }
              </div>
              <br/>
              <ChartPane data={chartFrqData}
                         processor={() => chartFrqData}
                         layoutProcessor={() => setFrqChartLayoutBar(chartFrqData.max, chartFrqData.interval)}
                         style={
                           {height: 500, width: '100%'}
                         }
              />
            </>
          </Tabs.TabPane>

        </Tabs>
      </div>
    </>
  );
  }
;

//2020.06.01 : MHz 단위 표기 추가
const MHZ_HELPER = {
  position: 'relative',
  float: 'right',
  fontSize: '12px',
}

const CHART_PANE_STYLE = {
  position: 'absolute',
  padding: '14px',
  margin: '8px',
  background: 'rgba(255, 255, 255, 1)',
  right: 36,
  top: 76,
  width: '700px',
  height: '600px',
  overflowX: 'auto',
  overflowY: 'auto',
  border: '1px solid grey',
  zIndex: 1,
};


const STYLE_CONTENT = {
  height: '100%',
  marginBottom: '30px',
  // overflowY: 'scroll',
};


const STYLE_SUBMIT = {
  position: 'absolute',
  top: -10,
  right: 2,
  padding: '10px 12px',
};

const dataZeroRemoveFn = (dataList) => {
  if (dataList) {
    return dataList.filter(obj => obj.cnt !== 0);
  }
};


//2020.06.01 : 셀렉터 초기조건 좌측 및 기본넓이 조정완료
const setChartLayoutBar = (maximum, interval) => {
  return '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Options>'
    + '<Caption text="지역별 무선국 정보 " textAlign="center" />'
    //+'<Caption text="지역별 무선국 정보 &lt;a href=javascript:cartDownload(\'chart1\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart1\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt;" textAlign="center" />'
    + '</Options>'
    + '<HistoryChart>'
    + '<displayerChart>'
    + '<Displayer id="chart1" dataTipJsFunction="dataTipFuncHis" showDataTips="true" width="100%" height="100%">'
    + '<horizontalAxis>'
    + '<CategoryAxis id="mainHAxis" categoryField="disNm" ticksBetweenLabels="true" padding="0.5" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis2DRenderer axis="{mainHAxis}"  canDropLabels="false" labelRotation="0" fontSize="11" showLine="true"/>'
    /* labelRotation 수치라벨을 기울입니다. */
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis maximum="' + maximum + '" interval="' + interval + '" formatter="{numfmt}" />'
    + '</verticalAxis>'
    + '<series>'
    + '<Column2DSet type="clustered" columnWidthRatio="0.5">'
    + '<series>'
    + '<Column2DSeries id="columnSeries" yField="cnt" displayName="Data1">'
    + '<fill>'
    + '<SolidColor color="#41b2e6"/>'
    + '</fill>'
    /* 디스플레이어 차트로 Column2DSeries를 정의 하였습니다 */
    + '<showDataEffect>'
    + '<SeriesInterpolate duration="1000"/>'
    + '</showDataEffect>'
    + '</Column2DSeries>'
    + '</series>'
    + '</Column2DSet>'
    + '</series>'
    + '</Displayer>'
    + '</displayerChart>'
    + '<navigator>'
    + '<Navigator id="navi" width="100%"  height="40" gutterLeft="0" gutterBottom="0" paddingLeft="2" paddingRight="2">'
    + '<horizontalAxis>'
    + '<CategoryAxis categoryField="disNm" id="naviHAxis"  padding="0"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis2DRenderer axis="{naviHAxis}" visible="false"/>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis}" visible="false"/>'
    + '</verticalAxisRenderers>'
    + '<backgroundElements>'
    + '<GridLines direction="horizontal"/>'
    + '</backgroundElements>'
    + '<series>'
    + '<Column2DSeries yField="cnt">'
    + '<fill>'
    + '<SolidColor color="#074d81"/>'
    + '</fill>'
    + '</Column2DSeries>'
    + '</series>'
    + '</Navigator>'
    + '</navigator>'
    + '<selector>'/* 시작 시 보여지는 차트는 총 데이터의 약 40%이며 센터 영역입니다. */
    + '<HistoryRangeSelector width="100%" startingRange="left" visibleItemSize="60"/>'
    + '</selector>'
    + '</HistoryChart>'
    + '</rMateChart>';
};
const setFrqChartLayoutBar = (maximum, interval) => {
    return '<rMateChart backgroundColor="#FFFFFF" borderStyle="none">'
        + '<Options>'
        + '<Caption text="대역별 무선국 정보" />'
        + '</Options>'
        + '<Bar2DChart showDataTips="true">'
        + '<verticalAxis>'
        + '<CategoryAxis id="hAxis" categoryField="band" labelJsFunction="axisLabelFunc"/>'
        + '</verticalAxis>'
        + '<series>'
        + '<Bar2DSeries xField="cnt" displayName="cnt" visibleItemSize="20" >'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Bar2DSeries>'
        + '</series>'
        + '</Bar2DChart>'
        + '</rMateChart>';
};
export default RMateChartTableImpCheck;
